import * as React from "react"
const InOuticon = (props) => (
   <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 682.667 682.667"
    {...props}
  >
    <g>
      <defs>
        <clipPath id="b" clipPathUnits="userSpaceOnUse">
          <path
            fill="#fff"
            d="M0 512h512V0H0Z"
            data-original-color="#000000ff"
          />
        </clipPath>
      </defs>
      <mask id="a">
        <rect width="100%" height="100%" fill="#fff" />
      </mask>
      <g mask="url(#a)">
        <g
          clipPath="url(#b)"
          transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
        >
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="m0 0-62.933-62.933-63.639 63.64"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "butt",
              strokeLinejoin: "miter",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(202 90.933)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="M0 0c0 65.17 52.831 118 118 118S236 65.17 236 0"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "butt",
              strokeLinejoin: "round",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(20 253)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="M0 0c0 33.137 26.863 60 60 60s60-26.863 60-60-26.863-60-60-60S0-33.137 0 0Z"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(79 432)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="M0 0c0 65.17 52.831 118 118 118S236 65.17 236 0"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "butt",
              strokeLinejoin: "round",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(256)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="M0 0c0 33.137 26.863 60 60 60s60-26.863 60-60-26.863-60-60-60S0-33.137 0 0Z"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(315 179)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="M0 0v184"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "butt",
              strokeLinejoin: "miter",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(139.067 28)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="m0 0 62.933 62.933 63.639-63.64"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "butt",
              strokeLinejoin: "miter",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(312.428 421.067)"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={40}
            d="M0 0v-186"
            data-original-stroke-color="#000000ff"
            data-original-stroke-width={40}
            style={{
              strokeLinecap: "butt",
              strokeLinejoin: "miter",
              strokeMiterlimit: 10,
              strokeDasharray: "none",
            }}
            transform="translate(375 484)"
          />
        </g>
      </g>
    </g>
  </svg>
)
export default InOuticon
